const data = { email: 'email', refreshToken: "refreshToken", tokenB: "tokenB", expiryAt: 0, accessToken: 'accessToken', tokenA: "tokenA", tokenC: "tokenC" }
const pdpaChannelData = { email: 'email', refreshToken: "refreshToken", access_token: "access_token", expiryAt: 0 }
const udfDefaultState = JSON.stringify(data)
const pdpaDefaultState = JSON.stringify(pdpaChannelData)

const getLocalItem = () => {
  return (typeof window !== 'undefined') && window.localStorage.getItem('myudf_token') ||
    (typeof window !== 'undefined') && window.localStorage.getItem('udf_token') || udfDefaultState;
};

const getLocalRefreshToken = () => {
  const UDFData = JSON.parse(getLocalItem())
  if (localStorage.getItem('udf_token')) return UDFData?.tokenC
  return UDFData?.refreshToken || ''
}

const getLocalAccessToken = () => {
  const UDFData = JSON.parse(getLocalItem())
  if (localStorage.getItem('udf_token')) return UDFData?.tokenA
  return UDFData?.tokenB || ''
}

const getLocalTokenData = () => {
  const UDFData = JSON.parse(getLocalItem())
  return UDFData
}

const getLocalExpiryAt = () => {
  const UDFData = JSON.parse(getLocalItem())
  return UDFData?.expiryAt || 0
}

const setLocalTokenData = (data) => {
  localStorage.setItem('myudf_token', JSON.stringify(data))
}

const removeLocalTokenData = () => {
  localStorage.removeItem('myudf_token')
  localStorage.removeItem('udf_token')
  localStorage.removeItem('_udfChannelToken')
}

const setEmpowerTokenData = (data) => {
  localStorage.setItem('udf_token', JSON.stringify(data))
}

const removeEmpowerTokenData = () => {
  localStorage.removeItem('udf_token')
}

const getPdpaChannelToken = () => {
  const pdpaData = JSON.parse(localStorage.getItem('channelTokenPdpa') || pdpaDefaultState)
  return pdpaData?.access_token;
}

const getLocalPdpaTokenData = () => {
  const pdpaData = JSON.parse(localStorage.getItem('pdpaToken') || pdpaDefaultState)
  return pdpaData
}

const getPDPALocalRefreshToken = () => {
  const pdpaData = JSON.parse(localStorage.getItem('pdpaToken') || pdpaDefaultState)
  return pdpaData?.refreshToken
}

const setUDFChannelToken = (data) => {
  localStorage.setItem('_udfChannelToken', data)
}

const getUDFChannelToken = () => {
  return localStorage.getItem('_udfChannelToken') || ''
}


const TokenService = {
  getLocalRefreshToken,
  getLocalAccessToken,
  getLocalTokenData,
  getLocalExpiryAt,
  setLocalTokenData,
  removeLocalTokenData,
  setEmpowerTokenData,
  removeEmpowerTokenData,
  getPdpaChannelToken,
  getLocalPdpaTokenData,
  getPDPALocalRefreshToken,
  setUDFChannelToken,
  getUDFChannelToken
}

export default TokenService